/* eslint-disable new-cap */
/* eslint-disable camelcase */
import { Images, Tweens } from '@abcya/abcya_phaser';
import Phaser from 'phaser';
import BasicSprite from '../BasicSprite';
import OrbitingSprite from '../OrbitingSprite';

export default class PlayerSpaceship_Horizontal extends OrbitingSprite {
  constructor(game, x, y) {
    super();
    this.y = y;
    this.game = game;
    this.sprite = game.add.container(x, y);
    const rocketShip = new BasicSprite(this.game, 0, 0, 'rocket');
    this.rocketShip = rocketShip;
    this.rocketFlame = new Phaser.GameObjects.Sprite(this.game, -25, 70, Images.DEFAULT_ATLAS, 'rocketFlame_Vertical');
    this.rocketShip.angle = 90;

    this.scale = 1;

    this.rocketShip.setScale(this.scale);
    this.rocketFlame.setScale(this.scale);

    this.rocketFlame.setScale(0);

    this.game.add.existing(this.sprite);

    this.sprite.add(rocketShip);
    this.sprite.add(this.rocketFlame);
  }

  FlyAway() {
    Tweens.addTween(this.rocketFlame, 500, { y: this.scale * .5, x: this.scale * .8 }, Phaser.Math.Easing.Circular.Out, () => {
      Tweens.addTween(this.rocketFlame, 200, { y: this.scale * .4, x: this.scale * .9 }, Phaser.Math.Easing.Circular.InOut, () => {
        Tweens.addTween(this.rocketFlame, 500, { y: this.scale * 1, x: this.scale * 1 }, Phaser.Math.Easing.Circular.Out);
      });
    });
    Tweens.addTween(this.rocketShip, 3000, { x: 3400 }, Phaser.Math.Easing.Circular.In);
    this.game.cameras.main.shake(0.001, 1000);
  }

  Update() {
    super.Update();
    if (this.particlesEnabled) {
      this.emitter.forEachAlive(this.fadeParticle);
    }
  }
}


